import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { DefaultButton, Dropdown, Modal, PrimaryButton } from '@fluentui/react';
import * as Api from '../../../../api/src';
import ModalHeader from '../../../../control/modalHeader';
import { commonfn } from '../../../../common/commonfn';
export interface ModaFilterTestProps {
  IsOpen: boolean;

  onCloseModal: () => void;
  onOkClick?: (FilterItem: Api.GetPagedTestsQuery) => void;
  FilterItem?: Api.GetPagedTestsQuery | null;
}
const ComponentsApi = new Api.ComponentsApi();
const VendorsApi = new Api.VendorsApi();
const ModaFilterTest = ({ FilterItem, IsOpen, onCloseModal, onOkClick }: ModaFilterTestProps) => {
  const { t } = useTranslation();
  const [isShow, SetIsShow] = React.useState(false);
  const [filterItem, SetFilterItem] = React.useState<Api.GetPagedTestsQuery>({});
  const [listVendors, setListVendors] = React.useState<any[]>([]);
  const [listComponent, setListComponent] = React.useState<any[]>([]);
  const [listStatus, setListStatus] = React.useState<any[]>([
    { key: Api.TestStatusQueryEnum.All, text: t('All') },
    { key: Api.TestStatusQueryEnum.Approved, text: t('Approved') },
    /* { key: Api.TestStatusQueryEnum.Expired, text: t('Expired') }, */
    { key: Api.TestStatusQueryEnum.OnGoing, text: t('OnGoing') },
  ]);
  React.useEffect(() => {
    SetIsShow(IsOpen);
    if (IsOpen) {
      if (filterItem != null) {
        SetFilterItem(FilterItem || {});
      } else {
        SetFilterItem({});
      }
      getAllVendors();
      getAllComponents();
    }
  }, [IsOpen]);
  const getTitle = (): string => {
    return t('Filter');
  };
  const onClose = () => {
    onCloseModal();
    SetIsShow(false);
  };
  const onSave = async () => {
    SetIsShow(false);
    if (onOkClick) {
      onOkClick(filterItem);
    }
  };
  const getAllVendors = async () => {
    if (listVendors.length > 0) return;
    let data = (
      await VendorsApi.apiVendorsPagedPost({
        PageNumber: 1,
        OrderBy: [{ ColumnName: 'Name' }],
        PageSize: 0,
        SearchString: '',
        GetOnlyActive: true,
      })
    ).data;
    let vendors: any[] = [{ key: 0, text: t('AllVendors') }];
    data.Data?.forEach((element) => {
      vendors.push({ key: element.Id, text: element.Name });
    });
    setListVendors(vendors);
  };
  const getAllComponents = async () => {
    let data = (
      await ComponentsApi.apiComponentsPagedPost({
        PageNumber: 1,
        OrderBy: [{ ColumnName: 'Name' }],
        PageSize: 0,
        SearchString: '',
        GetOnlyActive: true,
        ProductTypeId: FilterItem?.ProductTypeId,
      })
    ).data;
    let components: any[] = [{ key: 0, text: t('AllComponents') }];
    data.Data?.forEach((element) => {
      components.push({ key: element.Id, text: element.Name });
    });
    setListComponent(components);
  };
  return (
    <Modal isOpen={isShow} isModeless={true}>
      <ModalHeader
        title={getTitle()}
        onCloseModal={() => {
          onClose();
        }}
      />
      <div className={'modal-content'} style={{ width: 700 }}>
        <div className="ms-Grid" dir="ltr">
          <div className="ms-Grid-row">
            <div className="ms-md6 padding-left-0 ms-Grid-col">
              <Dropdown
                options={listVendors}
                label={t('Vendor')}
                selectedKey={filterItem?.VendorId || 0}
                defaultSelectedKey={filterItem?.VendorId || 0}
                onChange={(e, opt, index) => {
                  if (opt?.key) {
                    SetFilterItem({ ...filterItem, VendorId: parseInt(opt?.key.toString()) });
                  }
                }}
              ></Dropdown>
            </div>
            <div className="ms-md6 padding-right-0 ms-Grid-col">
              <Dropdown
                options={listComponent}
                label={t('Component')}
                selectedKey={filterItem?.ComponentId || 0}
                defaultSelectedKey={filterItem?.ComponentId || 0}
                onChange={(e, opt, index) => {
                  if (opt?.key) {
                    SetFilterItem({ ...filterItem, ComponentId: parseInt(opt?.key.toString()) });
                  }
                }}
              ></Dropdown>
            </div>
          </div>
          <div className="ms-Grid-row">
            <div className="ms-md6  padding-left-0 ms-Grid-col">
              <Dropdown
                options={listStatus}
                label={t('Status')}
                selectedKey={filterItem?.Status || ''}
                defaultSelectedKey={filterItem?.Status || ''}
                onChange={(e, opt, index) => {
                  if (opt?.key) {
                    SetFilterItem({ ...filterItem, Status: opt?.key as Api.TestStatusQueryEnum });
                  }
                }}
              ></Dropdown>
            </div>
          </div>
        </div>
      </div>
      <div className={'modal-footer'}>
        <DefaultButton
          onClick={() => {
            onClose();
          }}
          className={'margin-left-10'}
        >
          {t('Close')}
        </DefaultButton>
        <PrimaryButton
          className={'margin-left-10'}
          onClick={() => {
            onSave();
          }}
        >
          {t('ApplyFilter')}
        </PrimaryButton>
      </div>
    </Modal>
  );
};
export default ModaFilterTest;
